import React from 'react';

/** Decorative only: never intercepts clicks, focus, scrolling or media controls. */
export default function OfficeBackdrop() {
  return null;
}
